export default __webpack_public_path__ + "static/media/tea.7bf3b48f.svg";